import {
    Box,
    Button,
    Heading,
    Icon,
    Icons,
    Stack,
    Text,
    ThemeFontSizeVariable,
    ThemeIconSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import React from "react";

interface ErrorTemplateProps {
    btnCallback?: () => void;
    btnText?: string;
    icon: Icons | JSX.Element;
    title: string;
    message: string;
    isBtnLoading?: boolean;
    trackingId?: string;
}

const ErrorTemplate = ({
    btnCallback,
    btnText,
    icon,
    title,
    message,
    isBtnLoading,
    trackingId,
}: ErrorTemplateProps) => {
    return (
        <Box
            data-testid="error-template"
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={ThemeSpaceVariable.Medium}
            mt={ThemeSpaceVariable.Large}
        >
            {React.isValidElement(icon) ? (
                icon
            ) : (
                <Icon icon={icon as Icons} color="#242236" size={ThemeIconSizeVariable.X3Large} />
            )}
            <Stack textAlign="center" alignItems="center" spacing={ThemeSpaceVariable.Small}>
                <Heading fontWeight="medium" as="h2">
                    {title}
                </Heading>
                <Text fontSize={ThemeFontSizeVariable.Large} textAlign="center">
                    {message}
                </Text>
                {btnCallback && (
                    <Button
                        variant="primary"
                        onClick={btnCallback}
                        isLoading={isBtnLoading}
                        data-track-click={trackingId}
                    >
                        {btnText}
                    </Button>
                )}
            </Stack>
        </Box>
    );
};

export default ErrorTemplate;
